const DayRatingColors = {
    1:  '#ff3e36', // darkest red
    2:  '#ff643c',
    3:  '#ff7c42',
    4:  '#ff9746',
    5:  '#ffb44b',
    6:  '#ffd24f',
    7:  '#ddde55',
    8:  '#b0d85a',
    9:  '#85d15f',
    10: '#5eca64'  // green
};

export default DayRatingColors;